import React from 'react'

import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import hooks from '@hooks'
import { IApplicationState } from '@store'
import {
  IMediaTransferRequestParams,
  mediaTransferRequest,
  selectDefaultAdAccountId,
  selectHasFetchedAdAccounts,
  selectIsTransferringMedia,
} from '@store/facebookAds'
import FacebookAdAccountsModal from './FacebookAdAccountsModal'

interface IFacebookAdAccountsProps {
  onDone?: VoidFunction
  onMount?: VoidFunction
  mediaTransferProps: IMediaTransferRequestParams
}

export const FacebookAdAccounts: React.FC<IFacebookAdAccountsProps> = ({
  onDone,
  onMount,
  mediaTransferProps,
}) => {
  const dispatch = useDispatch()
  const { hasFetchedAdAccounts, defaultAccountId, isTransferringMedia } = useSelector(
    (state: IApplicationState) => ({
      hasFetchedAdAccounts: selectHasFetchedAdAccounts(state),
      defaultAccountId: selectDefaultAdAccountId(state) || '',
      isTransferringMedia: selectIsTransferringMedia(state),
    }),
    shallowEqual,
  )

  const isMounted = hooks.useIsMounted()
  const [isOpen, setIsOpen] = React.useState(false)
  const [selectedAccountId, setSelectedAccountId] = React.useState(defaultAccountId)

  React.useEffect(() => {
    if (isMounted && hasFetchedAdAccounts) {
      if (onMount) {
        onMount()
      }
      setSelectedAccountId(defaultAccountId)
      setIsOpen(true)
    }
  }, [hasFetchedAdAccounts])

  React.useEffect(() => {
    if (isMounted && !isTransferringMedia) {
      onCloseModal()
    }
  }, [isTransferringMedia])

  const onSelectAccountId = (adAccountId: string) => {
    setSelectedAccountId(adAccountId)
  }

  const onCloseModal = () => {
    setIsOpen(false)
    if (onDone) {
      onDone()
    }
  }

  const onSubmit = () => {
    dispatch(mediaTransferRequest(selectedAccountId, mediaTransferProps))
  }

  return (
    <FacebookAdAccountsModal
      isOpen={isOpen}
      isTransferringMedia={isTransferringMedia}
      onCloseModal={onCloseModal}
      onSelectAccountId={onSelectAccountId}
      selectedAccountId={selectedAccountId}
      onSubmit={onSubmit}
    />
  )
}

export default FacebookAdAccounts
